import React from 'react'
// @ts-ignore
import Fade from 'react-reveal/Fade'
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import { TwoTitle } from '../atoms/two_title'
import { Image } from '../atoms/image'

export const FlowView = () => {

  const cards: Array<Partial<{ type: "flow" | "arrow", imageName: string, title: string, description: string }>> = [
    { type: "flow", imageName: "flow1.jpg", title: "説明", description: "オンラインで説明（所要時間60分）" },
    { type: "arrow" },
    { type: "flow", imageName: "flow2.jpg", title: "契約", description: "オンラインの電子署名で契約" },
    { type: "arrow" },
    { type: "flow", imageName: "flow3.jpg", title: "アカウント発行", description: "アカウント発行後、\n即日サービスの提供が可能" },
  ]

  return (
    <section className="content">
      <section className="flowView content--standard">
        <TwoTitle jpnLabel='導入の流れ' engLabel='Introduction flow' />
        <section className="flowView--listArea">
          {cards.map((card, key) =>
            card.type === "flow"
              ?
              <div className="flowView--item">
                <div className="flowView--item--imageArea">
                  {card.imageName && <Image imageName={card.imageName} className="flowView--item--imageArea__image" />}
                </div>
                <div className="flowView--item--descriptionArea">
                  <h4 className="flowView--item--descriptionArea__title">{card.title}</h4>
                  <p className="flowView--item--descriptionArea__description">{card.description}</p>
                </div>
              </div>
              :
              <div className="flowView--icon">
                <i className="flowView--icon__icon flowView--icon__icon__pc fas fa-chevron-right"></i>
                <i className="flowView--icon__icon flowView--icon__icon__sp fas fa-chevron-down"></i>
              </div>
          )}
        </section>
      </section>
    </section>
  )
}